import Guid from '@/app/utils/guid'
import Entity from '@/common/models/entity'

export default class Judge extends Entity {
  public email = ''
  public name = ''
  public evaluationId = Guid.empty()
}
